/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarContact_viewer$ref = any;
export type PdpRespSidebarContact_viewer = {
    readonly isContactSupportEnabled: boolean | null;
    readonly isMessageCenterEnabled: boolean | null;
    readonly " $refType": PdpRespSidebarContact_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isContactSupportEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CONTACT_1STDIBS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CONTACT_1STDIBS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    }
  ]
};
(node as any).hash = '5f542e28d69328d74872b388d9d80215';
export default node;
